import PropTypes from 'prop-types';
import React from 'react';
import PureComponent from '../../pure';

import Button from '../../formElements/Button';
import Loader from '../../loader';
import sAction from 'sAction';
import moment from 'moment';
import PerilIcon from 'ROOT/views/portal/components/list/PerilIcon';
import assembleURLHash from '../../../action/Base/route/assembleURLHash';

export default class FileDownload extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            id: null,
            name: null,
            filename: null,
            visibility: null,
            description: null,
            valid_from: null,
            file_size: null,
            documentModel: null,
        };

        this.allowedModulesDownloadDialog = [
            'aon_portal_documents',
            'aon_event_response_files',
            'aon_model_and_software_updates',
        ];

        console.log('FileDownload constructor', this.props.data.get('moduleOrg'));
    }

    componentDidMount() {
        const data = this.props.data;
        const id = data.get('documentId');
        const moduleOrg = data.get('moduleOrg');

        console.log('FileDownload componentDidMount', moduleOrg);

        if (sAction.param.is_portal && id && this.allowedModulesDownloadDialog.includes(moduleOrg)) {
            this.setState({loading: true});
            const searchData = {
                getFields: [
                    'id',
                    'name',
                    'filename',
                    'visibility',
                    'description',
                    'valid_from',
                    'file_size',
                ],
                id: id,
                module: moduleOrg,
            };

            sAction.rest.post('getPortalDocumentData', searchData, (returnData) => {
                if (returnData.status) {
                    this.setState({
                        loading: false,
                        id: returnData.message.data.id,
                        name: returnData.message.data.name,
                        filename: returnData.message.data.filename.split('::')[1],
                        visibility: returnData.message.data.visibility,
                        description: returnData.message.data.description,
                        valid_from: moment(returnData.message.data.valid_from).format('DD.MM.YYYY'),
                        file_size: sAction.convertFileSize(returnData.message.data.file_size),
                        documentModel: returnData.message.data.model,
                    });
                } else {
                    this.setState({loading: false});
                }
            });
        }
    }

    /**
     * Copy file link to clipboard
     * @return {void}
     */
    copyFileLink = async () => {
        // generate file download link
        const module = this.props.data.get('moduleOrg');
        const urlHost = window.location.href.split('#')[0];
        const link = `${urlHost}${assembleURLHash('list', module, null, {action: 'download_file', id: this.state.id})}`;

        // copy link to clipboard
        try {
            await navigator.clipboard.write([
                new window.ClipboardItem({
                    'text/plain': new Blob([link], {type: 'text/plain'}),
                    'text/html': new Blob([`<a href="${link}">${this.state.name}</a>`], {type: 'text/html'}),
                }),
            ]);
            sAction.toast({
                name: 'Link copied to clipboard',
                description: ' ',
                sAction: null,
            });
        } catch (err) {
            console.warn('Failed to copy to clipboard: ', err);
            sAction.toast({
                name: 'Something went wrong',
                description: 'Your browser may not support copying to clipboard.',
                sAction: null,
            });
        }
    };

    render() {
        const data = this.props.data;
        const state = data.get('state');
        const link = sAction.param.files + 'downloadFile/' + data.get('token');
        const id = data.get('id');
        const moduleOrg = data.get('moduleOrg');
        const peril = this.state.documentModel?.peril;

        if (this.state.loading || state === 'load') {
            return <Loader />;
        }

        if (sAction.param.is_portal && id && this.allowedModulesDownloadDialog.includes(moduleOrg)) {
            return (
                <div className="fileDownload__popup">
                    <div className="acmPopupHeader accentPopup">
                        <p><span className='iconfa-fileDownload'></span> {sAction.translate('LBL_DOWNLOAD_FILE')}</p>
                    </div>
                    <div className="fileDownload">
                        <div className='downloadPopupTable'>
                            <div className='downloadPopupTableRow firstRow'>
                                <p>
                                    <b>{sAction.translate('LBL_DOWNLOAD_FILE_NAME')}: </b> {this.state.name}
                                    <span className='iconfa-copyLink copyLinkToClipboard'
                                        onClick={this.copyFileLink}
                                        title={sAction.translate('LBL_COPY_LINK_TO_CLIPBOARD')}>
                                    </span>
                                    <br/>
                                    <span className='labelSmall'>({this.state.filename})</span>
                                </p>
                                <PerilIcon value={peril} />
                                {/* <div className='perilIcon'>
                                    <img src={'img/peril-icons/Icons-' + peril + '@2x.png'} alt={peril} />
                                </div> */}
                            </div>
                            <div className='downloadPopupTableRow'>
                                <b>{sAction.translate('LBL_DOWNLOAD_FILE_DATE')}:&nbsp; </b> <p>{this.state.valid_from}</p>
                            </div>
                            <div className='downloadPopupTableRow'>
                                <b>{sAction.translate('LBL_DOWNLOAD_FILE_SIZE')}:&nbsp; </b> <p>{(this.state.file_size !== null ? this.state.file_size : '--')}</p>
                            </div>
                            {/* <div className='downloadPopupTableRow'>
                                <b>License:&nbsp; </b> <p>{this.state.visibility}</p>
                            </div> */}
                            <div className='downloadPopupTableRow rowDescription last'>
                                <b>{sAction.translate('LBL_DOWNLOAD_FILE_DESCRIPTION')}:&nbsp; </b> <p>{(this.state.description ? this.state.description : '--')}</p>
                            </div>

                            <div className='downloadPopupTableRow buttonRow'>
                                <Button
                                    className="popupDownloadButton"
                                    data-test={window.Cypress && link}
                                    onClick={() => {
                                        window.open(link, '_blank');
                                        sAction.popupHide();
                                    }}
                                >
                                    {sAction.translate('LBL_DOWNLOAD')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="fileDownload">
                {state == 'init' && (
                    <React.Fragment>
                        <div className="popupDownloadButton icon-download" data-test={window.Cypress && link}
                            onClick={() => {
                                window.open(link, '_blank');
                                sAction.popupHide();
                            }}
                        >
                        </div>
                        <span>{sAction.translate('LBL_DOWNLOAD_FILE', 'Documents')}</span>
                    </React.Fragment>
                )}
            </div>
        );
    }
}

FileDownload.propTypes = {
    data: PropTypes.shape({
        get: PropTypes.func,
    }),
    id: PropTypes.any,
    moduleOrg: PropTypes.string,
};
